import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "hidden md:block"
}
const _hoisted_2 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_3 = { class: "space-y-1 text-sm" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "flex items-center gap-2" }
const _hoisted_6 = {
  key: 1,
  class: "text-black"
}
const _hoisted_7 = { class: "flex justify-between" }
const _hoisted_8 = { class: "font-medium text-black" }
const _hoisted_9 = {
  key: 0,
  class: "text-red-600 ml-1"
}
const _hoisted_10 = { class: "mt-4 border-t border-gray-200 pt-4" }
const _hoisted_11 = { class: "space-y-2 text-sm" }
const _hoisted_12 = { class: "flex justify-between gap-4" }
const _hoisted_13 = { class: "text-black" }
const _hoisted_14 = { class: "font-medium text-black text-right" }
const _hoisted_15 = {
  key: 0,
  class: "flex justify-between gap-4"
}
const _hoisted_16 = { class: "font-medium text-black text-right" }
const _hoisted_17 = { class: "flex justify-between gap-4" }
const _hoisted_18 = { class: "font-medium text-black text-right" }
const _hoisted_19 = { class: "flex justify-between gap-4" }
const _hoisted_20 = { class: "font-medium text-black text-right" }
const _hoisted_21 = { class: "flex justify-between gap-4" }
const _hoisted_22 = { class: "font-medium text-black text-right" }
const _hoisted_23 = { class: "flex justify-between gap-4" }
const _hoisted_24 = { class: "font-medium text-black text-right" }
const _hoisted_25 = { class: "flex justify-between gap-4" }
const _hoisted_26 = { class: "font-medium text-black text-right" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 1,
  class: "mt-2 bg-gray-50 border border-gray-200 rounded-lg p-4"
}
const _hoisted_29 = { class: "flex items-center justify-between" }
const _hoisted_30 = { class: "text-black text-base font-semibold" }
const _hoisted_31 = {
  key: 2,
  class: "mt-2 bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-1"
}
const _hoisted_32 = { class: "flex items-center justify-between gap-3 mb-1" }
const _hoisted_33 = ["disabled", "title"]
const _hoisted_34 = {
  key: 0,
  class: "text-black text-sm"
}
const _hoisted_35 = {
  key: 1,
  class: "block md:hidden"
}
const _hoisted_36 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_37 = { class: "space-y-1 text-sm" }
const _hoisted_38 = { class: "flex justify-between items-center" }
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = {
  key: 1,
  class: "text-black"
}
const _hoisted_41 = { class: "flex justify-between" }
const _hoisted_42 = { class: "font-medium text-black" }
const _hoisted_43 = {
  key: 0,
  class: "text-red-600 ml-1"
}
const _hoisted_44 = { class: "mt-4 border-t border-gray-200 pt-4" }
const _hoisted_45 = { class: "space-y-2 text-sm" }
const _hoisted_46 = { class: "flex justify-between gap-4" }
const _hoisted_47 = { class: "text-black" }
const _hoisted_48 = { class: "font-medium text-black text-right" }
const _hoisted_49 = {
  key: 0,
  class: "flex justify-between gap-4"
}
const _hoisted_50 = { class: "font-medium text-black text-right" }
const _hoisted_51 = { class: "flex justify-between gap-4" }
const _hoisted_52 = { class: "font-medium text-black text-right" }
const _hoisted_53 = { class: "flex justify-between gap-4" }
const _hoisted_54 = { class: "font-medium text-black text-right" }
const _hoisted_55 = { class: "flex justify-between gap-4" }
const _hoisted_56 = { class: "font-medium text-black text-right" }
const _hoisted_57 = { class: "flex justify-between gap-4" }
const _hoisted_58 = { class: "font-medium text-black text-right" }
const _hoisted_59 = { class: "flex justify-between gap-4" }
const _hoisted_60 = { class: "font-medium text-black text-right" }
const _hoisted_61 = ["innerHTML"]
const _hoisted_62 = {
  key: 1,
  class: "mt-2 bg-gray-50 border border-gray-200 rounded-lg p-4"
}
const _hoisted_63 = { class: "flex items-center justify-between" }
const _hoisted_64 = { class: "text-black text-base font-semibold" }
const _hoisted_65 = {
  key: 2,
  class: "mt-2 bg-gray-50 border border-gray-200 rounded-lg p-4 space-y-1"
}
const _hoisted_66 = { class: "flex items-center justify-between gap-3 mb-1" }
const _hoisted_67 = ["disabled", "title"]
const _hoisted_68 = {
  key: 0,
  class: "text-black text-sm"
}
const _hoisted_69 = {
  key: 2,
  class: "text-sm text-black"
}
const _hoisted_70 = {
  key: 0,
  class: "mb-4 p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-sm text-yellow-800"
}
const _hoisted_71 = { class: "space-y-4" }
const _hoisted_72 = { class: "flex items-center justify-between mb-3" }
const _hoisted_73 = { class: "font-medium text-black" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "grid grid-cols-2 md:grid-cols-4 gap-3" }
const _hoisted_76 = { class: "text-sm text-black" }
const _hoisted_77 = ["onUpdate:modelValue"]
const _hoisted_78 = { class: "text-sm text-black" }
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = { class: "text-sm text-black" }
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = { class: "text-sm text-black" }
const _hoisted_83 = ["onUpdate:modelValue"]
const _hoisted_84 = {
  key: 1,
  class: "mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700"
}
const _hoisted_85 = {
  key: 2,
  class: "mt-4 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800"
}
const _hoisted_86 = ["disabled"]
const _hoisted_87 = ["disabled"]
const _hoisted_88 = {
  key: 0,
  class: "fas fa-spinner fa-spin mr-1"
}

import { inject, computed, ref, type ComputedRef } from 'vue'
import { DataCard, CarrierBadge, ModalComp } from '@/components'
import type { OrderDetailResponse, CarrierType, ParcelDimension } from '@/types'
import { mapCarrierIdToType } from '@/utils/carrierMapper'
import { formatDateFR } from '@/utils/date'
import { useAuthStore } from '@/stores/auth'
import { useNotification } from '@/composables/useNotification'
import { adminSaveParcelDimensions } from '@/api/orders'
import { mapToDeliveryAddress } from '@/utils/orderMapper'
import { getDomTomNameFromPostalCode } from '@/utils/domTom'
import {
  getCarrierDimensionLimits,
  validateColisDimensions,
} from '@/utils/parcelDimensionsLimits'

// Props
interface Props {
  orderId: number
  collapsible?: boolean
  carrierMessage?: string | null
  hasExistingLabels?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressDetails',
  props: {
    orderId: {},
    collapsible: { type: Boolean, default: false },
    carrierMessage: {},
    hasExistingLabels: { type: Boolean, default: false }
  },
  emits: ["collapsed"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

// État du collapse
const isCollapsed = ref(true)

// Récupérer les données depuis le parent via inject
const orderDetailDataInjected = inject<ComputedRef<{ value: OrderDetailResponse | null }>>('orderDetailData', computed(() => ({ value: null })))
const orderDetailData = computed(() => orderDetailDataInjected.value.value)
const reloadOrderData = inject<() => Promise<boolean>>('reloadOrderData')
const authStore = useAuthStore()
const { success, error: showError } = useNotification()
const isAdmin = computed(() => authStore.isImpersonating)
const showAdminDimensionsEditor = ref(false)
const isSavingDimensions = ref(false)
const editableParcelDimensions = ref<ParcelDimension[]>([])

const deliveryAddress = computed(() =>
  orderDetailData.value
    ? mapToDeliveryAddress(orderDetailData.value)
    : {
        enseigne: '',
        contact: '',
        adresse: '',
        codePostal: '',
        ville: '',
        pays: '',
        telephone: '',
      },
)

const deliveryCompanyLabel = computed(() =>
  orderDetailData.value?.adresseLivraison?.Societe?.trim()
    ? "Nom de l'enseigne"
    : 'Nom de la société',
)

const deliveryCountry = computed(() => {
  const country = orderDetailData.value?.adresseLivraison?.pays
  const countryName = country?.texte_fr?.trim() || deliveryAddress.value.pays
  const normalizedCountry = countryName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
  const isDomTom =
    country?.id_pays === 42 ||
    /france\s+dom[\s/-]*tom/.test(normalizedCountry)
  if (!isDomTom) return countryName

  const territory = getDomTomNameFromPostalCode(deliveryAddress.value.codePostal)
  return territory ? `${countryName} (${territory})` : countryName
})

const canAdminEditDimensions = computed(() => {
  const status = Number(orderDetailData.value?.statut)
  return isAdmin.value && status !== 2 && status !== 3
})

const adminEditBlockedReason = computed(() =>
  canAdminEditDimensions.value
    ? 'Modifier les dimensions des colis'
    : 'Modification impossible pour une commande expédiée ou annulée',
)

// Données transporteur
const carrier = computed<CarrierType | undefined>(() => {
  if (!orderDetailData.value?.livraison?.id_livraison) return undefined
  return mapCarrierIdToType(orderDetailData.value.livraison.id_livraison)
})

const carrierServiceName = computed<string>(() => {
  // PRIORITÉ 1: Utiliser le libelle exact depuis la base de données
  if (orderDetailData.value?.livraison?.libelle) {
    return `${orderDetailData.value.livraison.libelle} par Efashion Paris`
  }
  
  // FALLBACK: Utiliser le mapping si le libelle n'est pas disponible
  if (!carrier.value) return '-'
  const serviceNames: Record<CarrierType, string> = {
    colissimo: 'Colissimo par Efashion Paris',
    dpd: 'DPD par Efashion Paris',
    ups: 'UPS par Efashion Paris',
    gpx: 'GPX par Efashion Paris',
    ocx: 'OCX par Efashion Paris',
    chronopost: 'Chronopost par Efashion Paris',
    dhl: 'DHL par Efashion Paris',
    gls: 'GLS par Efashion Paris'
  }
  return serviceNames[carrier.value] || 'Transporteur par Efashion Paris'
})

const isGroupage = computed<boolean>(() => {
  return (
    orderDetailData.value?.commandeGroupe?.groupage === 1 ||
    orderDetailData.value?.groupage === true
  )
})

const shouldShowGroupageDate = computed<boolean>(() => {
  const dateExpedition = orderDetailData.value?.dateExpedition
  const idLivraison = Number(orderDetailData.value?.livraison?.id_livraison || 0)
  return (
    isGroupage.value &&
    !!dateExpedition &&
    dateExpedition !== '0000-00-00 00:00:00' &&
    idLivraison !== 1
  )
})

const groupageDateDisplay = computed<string>(() => {
  const dateExpedition = orderDetailData.value?.dateExpedition
  if (!dateExpedition || dateExpedition === '0000-00-00 00:00:00') return '-'
  try {
    return formatDateFR(dateExpedition)
  } catch {
    return dateExpedition
  }
})

// Dimensions des colis saisies par le grossiste, stockées dans
// commandes.data.infocolis.dimensioncolis (affichage en lecture seule).
const normalizeParcelDimension = (
  dim: Record<string, unknown> | unknown[],
): ParcelDimension => {
  const values = Array.isArray(dim)
    ? dim
    : [dim.longueur, dim.largeur, dim.hauteur, dim.poids]
  const numberOrNull = (value: unknown) => {
    const parsed = Number(value)
    return value !== '' && value != null && Number.isFinite(parsed)
      ? parsed
      : null
  }
  return {
    longueur: numberOrNull(values[0]),
    largeur: numberOrNull(values[1]),
    hauteur: numberOrNull(values[2]),
    poids: numberOrNull(values[3]),
  }
}

const parcelDimensions = computed<Array<Record<string, unknown> | unknown[]>>(() => {
  const raw: unknown = (orderDetailData.value as { data?: unknown } | null)?.data
  if (!raw) return []
  let parsed: unknown = raw
  if (typeof raw === 'string') {
    try {
      parsed = JSON.parse(raw)
    } catch {
      return []
    }
  }
  const infocolis = (parsed as { infocolis?: { dimensioncolis?: unknown; nbcolis?: unknown } } | null)?.infocolis
  const list = infocolis?.dimensioncolis
  if (!Array.isArray(list)) return []
  const nbColis = Number(infocolis?.nbcolis) || list.length
  return list.slice(0, nbColis)
})

const formatDimension = (dim: Record<string, unknown> | unknown[]): string => {
  const isArray = Array.isArray(dim)
  const obj = dim as Record<string, unknown>
  const arr = dim as unknown[]
  const longueur = isArray ? arr[0] : obj?.longueur
  const largeur = isArray ? arr[1] : obj?.largeur
  const hauteur = isArray ? arr[2] : obj?.hauteur
  const poids = isArray ? arr[3] : obj?.poids
  const size = `Long. ${longueur ?? '?'} × Larg. ${largeur ?? '?'} × Haut. ${hauteur ?? '?'} cm`
  return poids != null && poids !== '' ? `${size} — ${poids} kg` : size
}

const openAdminDimensionsEditor = () => {
  if (!canAdminEditDimensions.value) return
  editableParcelDimensions.value = parcelDimensions.value.length
    ? parcelDimensions.value.map(normalizeParcelDimension)
    : Array.from(
        { length: Math.max(1, Number(orderDetailData.value?.nb_colis) || 1) },
        () => ({ longueur: null, largeur: null, hauteur: null, poids: null }),
      )
  showAdminDimensionsEditor.value = true
}

const addEditableParcel = () => {
  editableParcelDimensions.value.push({
    longueur: null,
    largeur: null,
    hauteur: null,
    poids: null,
  })
}

const removeEditableParcel = (index: number) => {
  if (editableParcelDimensions.value.length <= 1) return
  editableParcelDimensions.value.splice(index, 1)
}

const dimensionValidationErrors = computed(() => {
  const errors: string[] = []
  editableParcelDimensions.value.forEach((colis, index) => {
    const number = index + 1
    if (
      colis.longueur == null ||
      colis.longueur <= 0 ||
      colis.largeur == null ||
      colis.largeur <= 0 ||
      colis.hauteur == null ||
      colis.hauteur <= 0 ||
      colis.poids == null ||
      colis.poids <= 0
    ) {
      errors.push(`Colis n°${number} : tous les champs doivent être supérieurs à 0.`)
    }
  })
  return errors
})

const dimensionLimitWarnings = computed(() => {
  const warnings: string[] = []
  const limits = getCarrierDimensionLimits(
    Number(orderDetailData.value?.livraison?.id_livraison) || null,
    orderDetailData.value?.adresseLivraison?.pays?.code,
    orderDetailData.value?.adresseLivraison?.codePostal,
  )
  editableParcelDimensions.value.forEach((colis, index) => {
    const number = index + 1
    if (
      colis.longueur == null ||
      colis.longueur <= 0 ||
      colis.largeur == null ||
      colis.largeur <= 0 ||
      colis.hauteur == null ||
      colis.hauteur <= 0 ||
      colis.poids == null ||
      colis.poids <= 0
    ) return

    if (colis.poids > limits.poids) {
      warnings.push(
        `Colis n°${number} : ${colis.poids} kg saisis, maximum ${limits.poids} kg.`,
      )
    }
    const dimensionWarning = validateColisDimensions(
      colis.longueur,
      colis.largeur,
      colis.hauteur,
      limits,
    )
    if (dimensionWarning) {
      warnings.push(`Colis n°${number} : ${dimensionWarning} — surtaxe possible.`)
    }
  })
  return warnings
})

const canSaveAdminDimensions = computed(
  () =>
    canAdminEditDimensions.value &&
    editableParcelDimensions.value.length > 0 &&
    dimensionValidationErrors.value.length === 0,
)

const savedDimensionsMatch = (expected: ParcelDimension[]): boolean => {
  const actual = parcelDimensions.value.map(normalizeParcelDimension)
  if (actual.length !== expected.length) return false

  return expected.every((expectedColis, index) =>
    (['longueur', 'largeur', 'hauteur', 'poids'] as const).every(
      (field) => Number(actual[index]?.[field]) === Number(expectedColis[field]),
    ),
  )
}

const saveAdminDimensions = async () => {
  if (!canSaveAdminDimensions.value || isSavingDimensions.value) return
  if (
    dimensionLimitWarnings.value.length > 0 &&
    !window.confirm(
      `Ces colis dépassent les seuils du transporteur et peuvent entraîner une surtaxe :\n\n${dimensionLimitWarnings.value.join('\n')}\n\nContinuer quand même ?`,
    )
  ) return
  isSavingDimensions.value = true
  let dimensionsSaved = false
  try {
    const expectedDimensions = editableParcelDimensions.value.map((colis) => ({
      ...colis,
    }))
    await adminSaveParcelDimensions(props.orderId, expectedDimensions)
    dimensionsSaved = true

    const refreshed = reloadOrderData ? await reloadOrderData() : false
    if (!refreshed || !savedDimensionsMatch(expectedDimensions)) {
      throw new Error(
        'Les données affichées ne correspondent pas aux dimensions enregistrées.',
      )
    }

    showAdminDimensionsEditor.value = false
    success(
      props.hasExistingLabels
        ? 'Dimensions enregistrées. Les étiquettes doivent être régénérées.'
        : 'Dimensions des colis enregistrées.',
    )
  } catch (err) {
    if (dimensionsSaved) {
      showAdminDimensionsEditor.value = false
      success(
        props.hasExistingLabels
          ? 'Dimensions enregistrées. Les étiquettes doivent être régénérées.'
          : 'Dimensions des colis enregistrées.',
      )
      showError(
        'Les dimensions ont été enregistrées, mais l’affichage n’a pas pu être actualisé. Rechargez la page.',
      )
      return
    }
    showError(
      err instanceof Error
        ? err.message
        : 'Impossible d’enregistrer les dimensions des colis.',
    )
  } finally {
    isSavingDimensions.value = false
  }
}

// Charger les adresses depuis les données de l'API
const toggleCollapse = () => {
  if (props.collapsible) {
    isCollapsed.value = !isCollapsed.value
    emit('collapsed', isCollapsed.value)
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataCard), {
    title: "Informations de livraison",
    icon: "fas fa-map-marker-alt",
    iconBgColor: "bg-green-100",
    iconColor: "text-green-600",
    clickable: false,
    className: "max-[600px]:p-4"
  }, _createSlots({
    default: _withCtx(() => [
      (orderDetailData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _cache[14] || (_cache[14] = _createElementVNode("h4", { class: "font-medium text-black mb-2 text-sm" }, "Informations de livraison", -1)),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-black" }, "Transporteur:", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      (carrier.value && Number(orderDetailData.value?.livraison?.id_livraison) !== 3 && Number(orderDetailData.value?.livraison?.id_livraison) !== 2)
                        ? (_openBlock(), _createBlock(_unref(CarrierBadge), {
                            key: 0,
                            carrier: carrier.value,
                            "show-name": true
                          }, null, 8, ["carrier"]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(Number(orderDetailData.value?.livraison?.id_livraison) === 3 ? 'Livraison offerte' : '-'), 1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-black" }, "Service:", -1)),
                    _createElementVNode("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(carrierServiceName.value) + " ", 1),
                      (isGroupage.value)
                        ? (_openBlock(), _createElementBlock("strong", _hoisted_9, "(groupage)"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _cache[10] || (_cache[10] = _createElementVNode("h4", { class: "font-medium text-black mb-2 text-sm" }, "Adresse de livraison", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(deliveryCompanyLabel.value) + ":", 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(deliveryAddress.value.enseigne || '-'), 1)
                      ]),
                      (deliveryAddress.value.contact)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-black" }, "Nom du contact:", -1)),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(deliveryAddress.value.contact), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-black" }, "Adresse:", -1)),
                        _createElementVNode("span", _hoisted_18, _toDisplayString(deliveryAddress.value.adresse || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-black" }, "Code postal:", -1)),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(deliveryAddress.value.codePostal || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-black" }, "Ville:", -1)),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(deliveryAddress.value.ville || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-black" }, "Pays:", -1)),
                        _createElementVNode("span", _hoisted_24, _toDisplayString(deliveryCountry.value || '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-black" }, "Téléphone:", -1)),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(deliveryAddress.value.telephone || '-'), 1)
                      ])
                    ])
                  ]),
                  (props.carrierMessage)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "mt-2 bg-blue-50 border border-blue-200 rounded-lg p-4 text-base text-black",
                        innerHTML: props.carrierMessage
                      }, null, 8, _hoisted_27))
                    : _createCommentVNode("", true),
                  (shouldShowGroupageDate.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-black text-base font-medium" }, "Date de groupage :", -1)),
                          _createElementVNode("p", _hoisted_30, _toDisplayString(groupageDateDisplay.value), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (parcelDimensions.value.length || isAdmin.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-black text-base font-medium" }, "Dimensions des colis :", -1)),
                          (isAdmin.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                disabled: !canAdminEditDimensions.value,
                                class: "px-3 py-1.5 text-xs font-medium border border-blue-500 text-blue-600 rounded-md hover:bg-blue-50 disabled:border-gray-300 disabled:text-gray-400 disabled:cursor-not-allowed",
                                title: adminEditBlockedReason.value,
                                onClick: openAdminDimensionsEditor
                              }, _cache[12] || (_cache[12] = [
                                _createElementVNode("i", { class: "fas fa-pen mr-1" }, null, -1),
                                _createTextVNode("Modifier ")
                              ]), 8, _hoisted_33))
                            : _createCommentVNode("", true)
                        ]),
                        (!parcelDimensions.value.length)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_34, " Aucune dimension renseignée "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parcelDimensions.value, (dim, i) => {
                          return (_openBlock(), _createElementBlock("p", {
                            key: i,
                            class: "text-black text-sm"
                          }, " Colis n°" + _toDisplayString(i + 1) + " : " + _toDisplayString(formatDimension(dim)), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (orderDetailData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
            _createElementVNode("div", {
              class: _normalizeClass([
          'transition-all duration-300 ease-in-out overflow-hidden',
          _ctx.collapsible ? (isCollapsed.value ? 'max-h-0 opacity-0' : 'max-h-screen opacity-100') : ''
        ])
            }, [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", null, [
                  _cache[27] || (_cache[27] = _createElementVNode("h4", { class: "font-medium text-black mb-2 text-sm" }, "Informations de livraison", -1)),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-black" }, "Transporteur:", -1)),
                      _createElementVNode("div", _hoisted_39, [
                        (carrier.value && Number(orderDetailData.value?.livraison?.id_livraison) !== 3 && Number(orderDetailData.value?.livraison?.id_livraison) !== 2)
                          ? (_openBlock(), _createBlock(_unref(CarrierBadge), {
                              key: 0,
                              carrier: carrier.value,
                              "show-name": true
                            }, null, 8, ["carrier"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(Number(orderDetailData.value?.livraison?.id_livraison) === 3 ? 'Livraison offerte' : '-'), 1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-black" }, "Service:", -1)),
                      _createElementVNode("span", _hoisted_42, [
                        _createTextVNode(_toDisplayString(carrierServiceName.value) + " ", 1),
                        (isGroupage.value)
                          ? (_openBlock(), _createElementBlock("strong", _hoisted_43, "(groupage)"))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "font-medium text-black mb-2 text-sm" }, "Adresse de livraison", -1)),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("span", _hoisted_47, _toDisplayString(deliveryCompanyLabel.value) + ":", 1),
                          _createElementVNode("span", _hoisted_48, _toDisplayString(deliveryAddress.value.enseigne || '-'), 1)
                        ]),
                        (deliveryAddress.value.contact)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-black" }, "Nom du contact:", -1)),
                              _createElementVNode("span", _hoisted_50, _toDisplayString(deliveryAddress.value.contact), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_51, [
                          _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-black" }, "Adresse:", -1)),
                          _createElementVNode("span", _hoisted_52, _toDisplayString(deliveryAddress.value.adresse || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_53, [
                          _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-black" }, "Code postal:", -1)),
                          _createElementVNode("span", _hoisted_54, _toDisplayString(deliveryAddress.value.codePostal || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-black" }, "Ville:", -1)),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(deliveryAddress.value.ville || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_57, [
                          _cache[21] || (_cache[21] = _createElementVNode("span", { class: "text-black" }, "Pays:", -1)),
                          _createElementVNode("span", _hoisted_58, _toDisplayString(deliveryCountry.value || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _cache[22] || (_cache[22] = _createElementVNode("span", { class: "text-black" }, "Téléphone:", -1)),
                          _createElementVNode("span", _hoisted_60, _toDisplayString(deliveryAddress.value.telephone || '-'), 1)
                        ])
                      ])
                    ]),
                    (props.carrierMessage)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "mt-2 bg-blue-50 border border-blue-200 rounded-lg p-4 text-base text-black",
                          innerHTML: props.carrierMessage
                        }, null, 8, _hoisted_61))
                      : _createCommentVNode("", true),
                    (shouldShowGroupageDate.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-black text-base font-medium" }, "Date de groupage :", -1)),
                            _createElementVNode("p", _hoisted_64, _toDisplayString(groupageDateDisplay.value), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (parcelDimensions.value.length || isAdmin.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createElementVNode("div", _hoisted_66, [
                            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "text-black text-base font-medium" }, "Dimensions des colis :", -1)),
                            (isAdmin.value)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  disabled: !canAdminEditDimensions.value,
                                  class: "px-3 py-1.5 text-xs font-medium border border-blue-500 text-blue-600 rounded-md hover:bg-blue-50 disabled:border-gray-300 disabled:text-gray-400 disabled:cursor-not-allowed",
                                  title: adminEditBlockedReason.value,
                                  onClick: openAdminDimensionsEditor
                                }, _cache[25] || (_cache[25] = [
                                  _createElementVNode("i", { class: "fas fa-pen mr-1" }, null, -1),
                                  _createTextVNode("Modifier ")
                                ]), 8, _hoisted_67))
                              : _createCommentVNode("", true)
                          ]),
                          (!parcelDimensions.value.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_68, " Aucune dimension renseignée "))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parcelDimensions.value, (dim, i) => {
                            return (_openBlock(), _createElementBlock("p", {
                              key: i,
                              class: "text-black text-sm"
                            }, " Colis n°" + _toDisplayString(i + 1) + " : " + _toDisplayString(formatDimension(dim)), 1))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true),
      (!orderDetailData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_69, " Chargement des données... "))
        : _createCommentVNode("", true),
      _createVNode(_unref(ModalComp), {
        isVisible: showAdminDimensionsEditor.value,
        "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => ((showAdminDimensionsEditor).value = $event)),
        title: "Modifier les dimensions des colis",
        size: "lg"
      }, {
        body: _withCtx(() => [
          (_ctx.hasExistingLabels)
            ? (_openBlock(), _createElementBlock("div", _hoisted_70, _cache[28] || (_cache[28] = [
                _createElementVNode("i", { class: "fas fa-triangle-exclamation mr-2" }, null, -1),
                _createTextVNode(" Des étiquettes existent déjà. Après la modification, elles devront être régénérées. ")
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_71, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editableParcelDimensions.value, (colis, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "border border-gray-200 rounded-lg p-4"
              }, [
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("span", _hoisted_73, "Colis n°" + _toDisplayString(index + 1), 1),
                  (editableParcelDimensions.value.length > 1)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "text-sm text-red-600 hover:text-red-700",
                        onClick: ($event: any) => (removeEditableParcel(index))
                      }, _cache[29] || (_cache[29] = [
                        _createElementVNode("i", { class: "fas fa-trash-alt mr-1" }, null, -1),
                        _createTextVNode("Supprimer ")
                      ]), 8, _hoisted_74))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("label", _hoisted_76, [
                    _cache[30] || (_cache[30] = _createTextVNode(" Longueur (cm) ")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((colis.longueur) = $event),
                      type: "number",
                      min: "0",
                      step: "0.1",
                      class: "mt-1 w-full px-3 py-2 border border-gray-300 rounded-md"
                    }, null, 8, _hoisted_77), [
                      [
                        _vModelText,
                        colis.longueur,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_78, [
                    _cache[31] || (_cache[31] = _createTextVNode(" Largeur (cm) ")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((colis.largeur) = $event),
                      type: "number",
                      min: "0",
                      step: "0.1",
                      class: "mt-1 w-full px-3 py-2 border border-gray-300 rounded-md"
                    }, null, 8, _hoisted_79), [
                      [
                        _vModelText,
                        colis.largeur,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_80, [
                    _cache[32] || (_cache[32] = _createTextVNode(" Hauteur (cm) ")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((colis.hauteur) = $event),
                      type: "number",
                      min: "0",
                      step: "0.1",
                      class: "mt-1 w-full px-3 py-2 border border-gray-300 rounded-md"
                    }, null, 8, _hoisted_81), [
                      [
                        _vModelText,
                        colis.hauteur,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_82, [
                    _cache[33] || (_cache[33] = _createTextVNode(" Poids (kg) ")),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((colis.poids) = $event),
                      type: "number",
                      min: "0",
                      step: "0.01",
                      class: "mt-1 w-full px-3 py-2 border border-gray-300 rounded-md"
                    }, null, 8, _hoisted_83), [
                      [
                        _vModelText,
                        colis.poids,
                        void 0,
                        { number: true }
                      ]
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "mt-4 px-3 py-2 text-sm border border-blue-500 text-blue-600 rounded-md hover:bg-blue-50",
            onClick: addEditableParcel
          }, _cache[34] || (_cache[34] = [
            _createElementVNode("i", { class: "fas fa-plus mr-1" }, null, -1),
            _createTextVNode("Ajouter un colis ")
          ])),
          (dimensionValidationErrors.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dimensionValidationErrors.value, (message) => {
                  return (_openBlock(), _createElementBlock("p", { key: message }, _toDisplayString(message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (dimensionLimitWarnings.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                _cache[35] || (_cache[35] = _createElementVNode("p", { class: "font-semibold mb-1" }, " Dépassement pouvant entraîner une surtaxe : ", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dimensionLimitWarnings.value, (message) => {
                  return (_openBlock(), _createElementBlock("p", { key: message }, _toDisplayString(message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 text-sm border border-gray-300 rounded-lg hover:bg-gray-50",
            disabled: isSavingDimensions.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showAdminDimensionsEditor.value = false))
          }, " Annuler ", 8, _hoisted_86),
          _createElementVNode("button", {
            type: "button",
            class: "px-4 py-2 text-sm bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed",
            disabled: !canSaveAdminDimensions.value || isSavingDimensions.value,
            onClick: saveAdminDimensions
          }, [
            (isSavingDimensions.value)
              ? (_openBlock(), _createElementBlock("i", _hoisted_88))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(isSavingDimensions.value ? 'Sauvegarde...' : 'Sauvegarder'), 1)
          ], 8, _hoisted_87)
        ]),
        _: 1
      }, 8, ["isVisible"])
    ]),
    _: 2
  }, [
    (_ctx.collapsible)
      ? {
          name: "header-toggle",
          fn: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "text-black md:hidden",
              onClick: _withModifiers(toggleCollapse, ["stop"])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass([
            'fas transition-transform duration-200',
            isCollapsed.value ? 'fa-chevron-down' : 'fa-chevron-up'
          ])
              }, null, 2)
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1024))
}
}

})